export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Enviado correctamente",
      error: "Error en el envío",
      notConfigured: "No configurado",
      pending: "Pendiente de envío",
    },
    errorNoInfo: "Error (sin información)",
  },
  msgPolice: {
    title: "Información",
    pendingSyncText:
      "Los datos del check-in están pendientes de sincronización, se enviaran a las Autoridades locales el mismo dia en que el huésped entre al alojamiento.",
    entryDateLabel: "Fecha de entrada:",
    syncedText:
      "Datos del huésped {name} han sido sincronizados con las Autoridades locales correctamente.",
    syncDateLabel: "Fecha de sincronización:",
    errorText:
      "Debido a motivos externos no se pudo completar la sincronización con las autoridades locales.",
    close: "Cerrar",
  },
};
